import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Package } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { products } from '../data/mock';

const Products = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-[400px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img
            src="https://images.unsplash.com/photo-1757283961544-e161ac41b201?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMHlhbXN8ZW58MHx8fHwxNzcxMjgwMTE4fDA&ixlib=rb-4.1.0&q=85"
            alt="Our Products"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#1B5E20]/80"></div>
        </div>
        
        <div className="container mx-auto px-4 z-10 relative text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">Our Products</h1>
          <p className="text-xl text-white/95 max-w-3xl mx-auto">
            Premium African agricultural products, quality-controlled and export-ready
          </p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {products.map((product) => (
              <Card key={product.id} className="overflow-hidden hover:shadow-2xl transition-all border-0 group">
                <div className="relative h-80 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
                  <div className="absolute top-4 right-4">
                    <span className="text-xs bg-[#C8A951] text-white px-3 py-1.5 rounded-full font-semibold shadow-lg">
                      {product.category}
                    </span>
                  </div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <h3 className="text-2xl font-bold text-white mb-2">{product.name}</h3>
                    <p className="text-white/90 text-sm">{product.description}</p>
                  </div>
                </div>
                <CardContent className="p-6">
                  <div className="space-y-3 mb-6">
                    <div className="flex items-start gap-2 text-sm">
                      <Package className="text-[#1B5E20] flex-shrink-0 mt-0.5" size={16} />
                      <div>
                        <span className="font-semibold text-[#333333]">Origin:</span>
                        <span className="text-gray-600 ml-1">{product.details.origin}</span>
                      </div>
                    </div>
                    <div className="flex items-start gap-2 text-sm">
                      <Package className="text-[#1B5E20] flex-shrink-0 mt-0.5" size={16} />
                      <div>
                        <span className="font-semibold text-[#333333]">MOQ:</span>
                        <span className="text-gray-600 ml-1">{product.details.moq}</span>
                      </div>
                    </div>
                  </div>
                  <Link to={`/products/${product.slug}`}>
                    <Button className="w-full bg-[#1B5E20] hover:bg-[#2E7D32] text-white transition-all">
                      View Full Details
                      <ArrowRight className="ml-2" size={16} />
                    </Button>
                  </Link>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-[#1B5E20] to-[#2E7D32] text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl font-bold mb-4">Interested in Our Products?</h2>
          <p className="text-xl mb-8 text-white/90 max-w-2xl mx-auto">
            Request a detailed quote with pricing, specifications, and shipping information
          </p>
          <Link to="/quote">
            <Button size="lg" className="bg-[#C8A951] hover:bg-[#B8994A] text-white font-semibold px-10 py-6 text-lg shadow-xl hover:shadow-2xl transition-all">
              Request a Quote
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Products;
